import { ART_TIER_COUNT } from './layer-stack'

export const TIERS = Array.from({ length: ART_TIER_COUNT }, (_v, tier) => tier)

/**
 * The config document for a SPECIFIC version, which is what makes an exact preview possible.
 *
 * `GET /v1/config/v<n>/<set>` selects by `(org, n)` with no channel check, so a version that has
 * been staged and never published is fully servable. Publishing only moves the `current` pointer
 * that players read — which is why previewing a draft needs no preview channel, and why the admin
 * can look at the real studio while players see nothing.
 */
export function configUrlForVersion(
  apiBaseUrl: string,
  version: number,
  setId: string,
): string {
  if (!Number.isInteger(version) || version < 1) {
    throw new Error(`preview needs a real version number, got ${version}`)
  }
  if (!setId) {
    throw new Error('preview needs a collection id')
  }

  return `${apiBaseUrl.replace(/\/$/, '')}/v1/config/v${version}/${encodeURIComponent(setId)}`
}

/** The player-facing URL, for contrast: what a real player would load right now. */
export function currentConfigUrl(apiBaseUrl: string, setId: string): string {
  return `${apiBaseUrl.replace(/\/$/, '')}/v1/config/current/${encodeURIComponent(setId)}`
}

export function isValidTier(tier: number): boolean {
  return Number.isInteger(tier) && tier >= 0 && tier < ART_TIER_COUNT
}

/**
 * Preview-staging burns a version number. They are monotonic and appear in asset URLs, so numbers
 * are cheap but not free — and a version staged only to look at must be labelled "never published"
 * so nobody mistakes it for something a player saw.
 */
export interface PreviewTarget {
  version: number
  setId: string
  tier: number
}

export function describePreviewCost(existingVersions: number): string {
  return `v${existingVersions + 1}`
}
